import {
  IBookableDate,
  IBookableDatesInfo,
  IDateInfo,
} from "@/domain/entities/book";
import dayjs from "dayjs";
import { injectable } from "inversify";

export interface BookableDatesInfoToDateInfosUseCase {
  execute(bookableDatesInfo: IBookableDatesInfo): IDateInfo[];
}

@injectable()
export class BookableDatesInfoToDateInfos
  implements BookableDatesInfoToDateInfosUseCase
{
  public execute(bookableDatesInfo: IBookableDatesInfo): IDateInfo[] {
    return bookableDatesInfo.bookableDates.map((bookableDate) =>
      this.createDateInfo(bookableDate)
    );
  }

  private createDateInfo(bookableDate: IBookableDate): IDateInfo {
    return {
      dayJs: dayjs(bookableDate.date),
      date: bookableDate.date,
      bookableDate: bookableDate,
    };
  }
}
